import { render, staticRenderFns } from "./PartnersSideviewTasksTab.vue?vue&type=template&id=a23052a4&scoped=true&class=fill-height&"
import script from "./PartnersSideviewTasksTab.vue?vue&type=script&lang=ts&"
export * from "./PartnersSideviewTasksTab.vue?vue&type=script&lang=ts&"
import style0 from "./PartnersSideviewTasksTab.vue?vue&type=style&index=0&id=a23052a4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a23052a4",
  null
  
)

export default component.exports